// extracted by mini-css-extract-plugin
module.exports = {"WrapperRatingByShop":"RatingByShop_WrapperRatingByShop__gahKG","Rating":"RatingByShop_Rating__pZxNH","Reviews":"RatingByShop_Reviews__6eGgd"};